import DropdownTemplateView from '../../../DropdownTemplateView'
import {connect} from '../../../redux/utils'
import ScrollableContainer from '../../../util/ScrollableContainer'
import AssignedTeamList from './AssignedTeamList'
import LoadingContainer from '../../../util/LoadingContainer'
import {getSortedTeamUsers, isLoading, isNeedToLoadData} from '../selectors'
import {bindActionCreators} from 'redux'
import {loadAssignedTeamNames, openTeamList} from '../actions'


class AssignedTeamDropdownListContainer extends DropdownTemplateView {
    constructor({
        additionalClass = '',
        loadTeamsData = () => {},
        onShowCallback = () => {},
    }) {
        super()

        this.loadTeamsData = loadTeamsData
        this.onShowCallback = onShowCallback
        this.additionalClass = additionalClass

        this.isShown = true

        this.state = {
            loading: false,
            needToLoadData: false,

            teamUsers: [],
        }

        this.onStatePropertyBecameTrue('needToLoadData', () => {
            this.loadTeamsData()
        })

        this.onStatePropertyChanged('loading', (loading) => {
            this.content.setState({
                loading: loading
            })
        })


        this.onStatePropertyChanged('teamUsers', (teamUsers) => {
            this.content.setState({
                teamUsers: teamUsers
            })
        })
    }

    templateHtml() {
        return '<div class="teamsContainer <%-additionalClass%>">' +
               '    <div class="pointerPlaceholder">' +
               '        <div class="pointer"/>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.additionalClass
        }
    }

    afterRender() {
        this.teamList = new AssignedTeamList()

        this.loadingContainer = new LoadingContainer({
            contentComponent: this.teamList,
            containerClass: '',
            loadingMoireConfig: {
                delay: 500
            }
        })

        this.content = new ScrollableContainer(null, this.loadingContainer).init(this.getEl())
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
    }
}

export default connect(
    state => ({
        loading: isLoading(state),
        needToLoadData: isNeedToLoadData(state),

        teamUsers: getSortedTeamUsers(state),
    }),
    dispatch => ({
        loadTeamsData: bindActionCreators(loadAssignedTeamNames, dispatch),
        onShowCallback: bindActionCreators(openTeamList, dispatch),
    })
)(AssignedTeamDropdownListContainer)



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/components/AssignedTeamListContainer.js